<div class="app-template-highspeed-course">
    <div class="slider-banner">
      <div ngImagePixel #bannermageHolder="imagePixel" class="banner-item">
            <img
            class="img-fluid"
            [src]="bannerImage+'?'+bannermageHolder.imagePixel+'&dpr=2&'+bannermageHolder.aspectRation+'&fit=crop&auto=compress&crop=left,entropy'"
            alt="banner-image"
          />

        <div class="carousel-caption">
          <div class="container">
            <h1 class="h1">Høyhastighetsbevis</h1>
          </div>
        </div>
      </div>
    </div>

    <main>
      <section class="about-section">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-8 offset-md-2">
              <div class="section-item">
                  <div class="section-header">
                    <h4 class="h4 font-weight-bold">Informasjon</h4>
                  </div>
                  <div>
                    <p class="p">
                      Høyhastighetskurset består av en teoretisk del med avsluttende prøve og en praktisk del på sjøen. Teoridelen varer i ca. 5-6 timer inkludert prøven. Praktisk del varer i 1,5 til 2,5 timer avhengig av antall deltagere.
                     <br>
                     <br>
                     Den teoretiske delen må være gjennomført før man kan ta den praktiske delen. Siden båt og vannscooter er to forskjellige fartøy vil den praktiske delen skille mellom disse. Skal du kjøre både vannscooter og båt må du ta praktisk del for begge fartøy (teori er lik og du trenger bare ta denne én gang).
                     <br>
                     <br>
                     <a [routerLink]="['/kursoversikt-for-tilbydere']"  class="information-link">Ønsker du å tilby høyhastighetskurs på RS Sjøliv? Les mer her <mat-icon class="ml-1 read-more-arrow align-middle">arrow_forward</mat-icon></a>
                    </p>
                  </div>
              </div>

              <div class="section-item border-0">
                <div class="section-header mb-2">
                  <h4 class="h4 font-weight-bold">Del 1: Teori</h4>
                </div>
                <p class="p">
                  Velg hvordan du ønsker å gjennomføre teori del 1. Teorien må være gjennomført før du tar praktisk del 2.
                </p>
                <div class="container px-md-0">
                    <div class="row">
                        <div class="col-12 col-md-4 mb-4 mb-md-0">
                           <app-highspeed-course-card>
                                <ng-container ngProjectAs="[title]">
                                    Digital nettkurs
                                </ng-container>
                                <ng-container ngProjectAs="[content]">
                                  Kjøp tilgang og ta kurset og teoretisk prøve med en gang eller når det passer deg.
                                </ng-container>
                                <ng-container ngProjectAs="[actionButton]">
                                    <a [routerLink]="['/digitalkurs/nettkurs-hoyhastighetsbevis-teori']"  class="btn btn-primary w-100">
                                        Kjøp tilgang
                                    </a>
                                </ng-container>
                           </app-highspeed-course-card>
                        </div>
                        <div class="col-12 col-md-4 mb-4 mb-md-0">
                            <app-highspeed-course-card>
                                <ng-container ngProjectAs="[title]">
                                   Webinar
                                </ng-container>
                                <ng-container ngProjectAs="[content]">
                                  Lærer du bedre ved å lytte og se? Her får du muligheten til å kommunisere med instruktøren underveis om du vil. Teoretisk prøve tas på slutten av kurset.
                                </ng-container>
                                <ng-container ngProjectAs="[actionButton]">
                                  <a [routerLink]="['/kursoversikt/webinar-hoyhastighetsbevis-teori']"  class="btn btn-primary w-100">
                                      Finn kurs
                                  </a>
                                </ng-container>
                           </app-highspeed-course-card>
                        </div>
                        <div class="col-12 col-md-4">
                            <app-highspeed-course-card>
                                <ng-container ngProjectAs="[title]">
                                    Klasserom
                                </ng-container>
                                <ng-container ngProjectAs="[content]">
                                    For deg som foretrekker undervisning i klasserom med instruktør. Prøven tas på slutten av kurset.
                                </ng-container>
                                <ng-container ngProjectAs="[actionButton]">
                                    <a [routerLink]="['/kursoversikt/klasserom-hoyhastighetsbevis-teori']"  class="btn btn-primary w-100">
                                      Finn kurs
                                    </a>
                                </ng-container>
                           </app-highspeed-course-card>
                        </div>
                    </div>
                </div>
              </div>
              <div class="section-item border-0">
                <div class="section-header mb-2">
                  <h4 class="h4 font-weight-bold">Del 2: Praktisk</h4>
                </div>
                <p class="p">
                   Etter du har gjennomført teorien kan du ta praktisk del 2. Velg mellom båt eller vannscooter. Skal du kjøre både vannscooter og båt så må du ta begge deler.
                </p>
                <div class="container px-md-0">
                    <div class="row">
                        <div class="col-12 col-md-4 mb-4 mb-md-0">
                           <app-highspeed-course-card [isContentUpperPadding]="true">
                                <ng-container ngProjectAs="[title]">
                                    Praktisk båt
                                </ng-container>
                                <ng-container ngProjectAs="[content]">
                                    Lengden på praktisk del varierer etter antall deltagere (maks 5).
                                </ng-container>
                                <ng-container ngProjectAs="[actionButton]">
                                    <a [routerLink]="['/kursoversikt/praktisk-del-bat-hoyhastighetsbevis']"  class="btn btn-primary w-100">
                                        Finn kurs
                                    </a>
                                </ng-container>
                           </app-highspeed-course-card>
                        </div>
                        <div class="col-12 col-md-4 mb-4 mb-md-0">
                            <app-highspeed-course-card [isContentUpperPadding]="true">
                                <ng-container ngProjectAs="[title]">
                                  Praktisk vannscooter
                                </ng-container>
                                <ng-container ngProjectAs="[content]">
                                  Lengden på praktisk del vannscooter varierer etter antall deltagere (maks 5).
                                </ng-container>
                                <ng-container ngProjectAs="[actionButton]">
                                    <a [routerLink]="['/kursoversikt/praktisk-del-vannscooter-hoyhastighetsbevis']"  class="btn btn-primary w-100">
                                        Finn kurs
                                    </a>
                                </ng-container>
                           </app-highspeed-course-card>
                        </div>
                    </div>
                </div>
              </div>
              <div class="section-item border-0">
                 <div class="section-header mb=2">
                      <a href="https://rs.no/hoyhastighetskurs/" target="_blank"  class="information-link">Se ofte stilte spørsmål om høyhastighetskurs. <mat-icon class="read-more-arrow align-middle">arrow_forward</mat-icon></a>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
